import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { User } from "../../../@types/user";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const findLegalReps = createAsyncThunk(
  "massiveDocumentCreate/findLegalReps",
  async (data, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}userprofile`, {
        params: {
          profile: 30,
        },
      });

      return data as User[];
    } catch (error:any) {
      const {message} = error
      rejectWithValue(message);
      throw message;
    }
  }
);
